<template>
  <svg width="34"
       height="35"
       viewBox="0 0 34 35"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <circle cx="17"
            cy="17.5"
            r="17"
            fill="#F05B5B"
            fill-opacity="0.12" />
    <circle cx="17" cy="17" r="10" fill="#F05B5B" />
    <path
      d="M23.6135 21.2419C23.5458 21.4281 23.4164 21.576 23.2535 21.6533C23.1733 21.6924 23.0872 21.7131 23.0001 21.7143L19.6668 21.7143C19.49 21.7143 19.3204 21.634 19.1954 21.4911C19.0704 21.3483 19.0001 21.1545 19.0001 20.9524C19.0001 20.7503 19.0704 20.5565 19.1954 20.4136C19.3204 20.2708 19.49 20.1905 19.6668 20.1905L21.3935 20.1905L17.6668 15.9314L15.4735 18.4457C15.4115 18.5171 15.3377 18.5738 15.2565 18.6125C15.1753 18.6512 15.0881 18.6711 15.0001 18.6711C14.9121 18.6711 14.825 18.6512 14.7437 18.6125C14.6625 18.5738 14.5888 18.5171 14.5268 18.4457L10.5268 13.8743C10.4643 13.8035 10.4147 13.7192 10.3809 13.6263C10.347 13.5335 10.3296 13.4339 10.3296 13.3333C10.3296 13.2328 10.347 13.1332 10.3809 13.0403C10.4147 12.9475 10.4643 12.8632 10.5268 12.7924C10.5888 12.721 10.6625 12.6643 10.7437 12.6256C10.825 12.5869 10.9121 12.567 11.0001 12.567C11.0881 12.567 11.1753 12.5869 11.2565 12.6256C11.3377 12.6643 11.4115 12.721 11.4735 12.7924L15.0001 16.8305L17.1935 14.3162C17.2554 14.2448 17.3292 14.1881 17.4104 14.1494C17.4916 14.1107 17.5788 14.0908 17.6668 14.0908C17.7548 14.0908 17.8419 14.1107 17.9232 14.1494C18.0044 14.1881 18.0781 14.2448 18.1401 14.3162L22.3335 19.1162L22.3335 17.1429C22.3335 16.9408 22.4037 16.747 22.5287 16.6041C22.6537 16.4612 22.8233 16.381 23.0001 16.381C23.1769 16.381 23.3465 16.4612 23.4715 16.6041C23.5966 16.747 23.6668 16.9408 23.6668 17.1429L23.6668 20.9524C23.6657 21.052 23.6476 21.1503 23.6135 21.2419Z"
      fill="white" />
  </svg>
</template>
<script>
export default {
  props: {}
}
</script>
